import { useRef } from 'react';
import { useAutomationSteps } from '@/hooks/useAutomationSteps';
import { AUTOMATION_STEPS } from '@/data/indexSections';
import { CountUp } from './CountUp';

export function AutomationSection() {
  const sectionRef = useRef(null);
  const { index: activeIndex, armed } = useAutomationSteps(sectionRef, AUTOMATION_STEPS.length);

  return (
    <section
      ref={sectionRef}
      id="automation"
      aria-labelledby="automation-title"
      className="automation-gradient relative h-[300vh] text-white"
      data-automation
    >
      <div className="automation-stage">
        {/* 헤딩: 상단 고정 */}
        <div className="inner absolute top-16 right-0 left-0 lg:top-24">
          <img
            src="/assets/icons/automation.png"
            alt=""
            aria-hidden="true"
            width="560"
            height="560"
            className="h-20 w-20"
            loading="lazy"
          />
          <h2 id="automation-title" className="heading-2 mt-8 text-white">
            자동화 수준의 변화
          </h2>
        </div>

        {/* 수치: 화면 세로 중앙 */}
        <div className="flex h-full items-center">
          <div className="inner">
            <div className="relative h-[340px] lg:h-[420px]">
              {AUTOMATION_STEPS.map((step, index) => {
                const active = index === activeIndex;
                return (
                  <div
                    key={step.label}
                    id={step.id}
                    className={active ? 'auto-step is-active' : 'auto-step'}
                    data-step={index}
                  >
                    <p className="stat-label">{step.label}</p>
                    <span aria-hidden="true" className="stat-divider" />
                    <p className="stat-value">
                      <CountUp to={step.value} active={active && armed} />
                      <span className="align-top">%</span>
                    </p>
                    <p className="stat-desc">
                      {step.desc[0]}
                      <br />
                      {step.desc[1]}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
